import fetch from 'isomorphic-fetch';

const ActionsTooling = {
  //only accept simple data types or arrays of simle data types
  simpleActionFunction: (action) => {
    return action;
  },
  defaultInitActionFunction: (actionType) => {
    return {
      type: actionType
    };
  },
  defaultSuccessActionFunction: (actionType, payload) => {
    return {
      type: actionType,
      payload: payload
    };
  },
  defaultErrorActionFunction: (actionType, error) => {
    return {
      type: actionType,
      error: error
    };
  },
  defaultExpressApiCall: async (url, method, params = null, body = null) => {
    const response = await fetch(url + (params ? "/" + encodeURIComponent(JSON.stringify(params)): ""), {
      method: method,
      headers: new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        credentials: 'include',
        Pragma: 'no-cache'
      }),
      body: body ? JSON.stringify(body) : null
    });
    const status = response.status;
    const data = await response.json();
    return { data: data, status: status };    
  }
};

export default ActionsTooling;


// WEBPACK FOOTER //
// ./source/tooling/actionsTooling.js